export default "__VITE_ASSET__BpeB1CK7__"